var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8HomePage50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e8eaf6",
    d: "M42 38L6 38 6 22 42 22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5cae9",
    d: "M39 21L34 21 34 9 39 9zM6 38H42V43H6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b71c1c",
    d: "M24 5L4 22.9 44 22.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d84315",
    d: "M18 27H30V43H18z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8a65",
    d: "M27.5,34c-0.3,0-0.5,0.2-0.5,0.5v2c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-2 C28,34.2,27.8,34,27.5,34z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8HomePage50);
export default __webpack_public_path__ + "static/media/icons8-home-page-50.a51e3bd1ac46662865bea01ee5ecbeec.svg";
export { ForwardRef as ReactComponent };